export const ACTION_MODULE_ID_PREFIX = 'action-module-id-';
export const getCommentableAreaId = moduleId => `#commentable-area-${moduleId}`;